<template>
  <section
    class="img-holder"
    :style="{ 'background-image': `url(${thumb})` }"
  ></section>
</template>

<script>
export default {
  props: ['product'],
  computed: {
    thumb() {
      if (this.product.isCustomizable) {
        return this.product.previewImage
      } else {
        return `/media/print-store/${this.product.printStoreId}/preview/${this.product.previewImage}/88`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-holder {
  width: 39px;
  height: 39px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 15px;
  flex-shrink: 0;
  flex-grow: 0;
}
</style>
